import { gql, useMutation } from '@apollo/client';

export const SEARCH_PAYMENT_METHODS = gql`
  query SearchPaymentMethods($query: String!) {
    searchPaymentMethods(query: $query) {
      id
      name
    }
  }
`;

export const GET_PAYMENT_METHOD_BY_ID = gql`
  query GetPaymentMethodById($id: ID!) {
    paymentMethod(id: $id) {
      id
      name
      paymentString
      updatedAt
      createdAt
    }
  }
`;

export const GET_PAYMENT_METHODS = gql`
  query GetPaymentMethods($page: Int, $perPage: Int, $search: String) {
    paymentMethods(page: $page, perPage: $perPage, search: $search) {
      edges {
        node {
          id
          name
          paymentString
          active
          updatedAt
          createdAt
        }
        cursor
      }
      pageInfo {
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`;

export const CREATE_PAYMENT_METHOD = gql`
  mutation CreatePaymentMethod($attributes: PaymentMethodAttributes!) {
    createPaymentMethod(input: { attributes: $attributes }) {
      paymentMethod {
        id
        name
        createdAt
        updatedAt
        active
        paymentString
      }
      errors
    }
  }
`;

export const UPDATE_PAYMENT_METHOD = gql`
  mutation UpdatePaymentMethod($id: ID!, $name: String!, $active: Boolean!, $paymentString: String) {
    updatePaymentMethod(input: { id: $id, name: $name, active: $active, paymentString: $paymentString }) {
      paymentMethod {
        id
        name
        createdAt
        updatedAt
        active
        paymentString
      }
      errors
    }
  }
`;

export const UPDATE_PAYMENT_METHOD_STATUS = gql`
  mutation UpdatePaymentMethodStatus($id: ID!, $active: Boolean!) {
    updatePaymentMethodStatus(input: { id: $id, active: $active }) {
      paymentMethod {
        id
        updatedAt
        active
      }
      errors
    }
  }
`;

export const useUpdatePaymentMethodStatus = () => {
  return useMutation(UPDATE_PAYMENT_METHOD_STATUS);
};

export const useCreatePaymentMethod = () => {
  return useMutation(CREATE_PAYMENT_METHOD);
};

export const useUpdatePaymentMethod = () => {
  return useMutation(UPDATE_PAYMENT_METHOD);
};
